import GCSE from '@mindful-web/marko-web-gcse/browser';
import ContactUs from '@mindful-web/marko-web-contact-us/browser';
import Leaders from '@mindful-web/marko-web-leaders/browser';
import MonoRail from '@mindful-web/marko-web-theme-monorail/browser';
import GlobalFloatingVideoPlayer from './floating-video-player.vue';
import BrightcoveGAMPlayer from './brightcove-gam-player.vue';

export default (Browser) => {
  GCSE(Browser);
  ContactUs(Browser);
  Leaders(Browser);
  MonoRail(Browser);
  Browser.register('GlobalFloatingVideoPlayer', GlobalFloatingVideoPlayer);
  Browser.register('BrightCoveGAMPlayer', BrightcoveGAMPlayer);
};
